import React from 'react';
import SimpleProductPage from './PriceComparison/SimpleProductPage';
import { 
  findProductById, 
 
  getProductImage, 
  getProductCsvLookupId 
} from '../utils/productHelpers';

const SimpleGT10HNIF = () => {
  console.log('🎯 SimpleGT10HNIF component loading');
  
  const product = findProductById("gt10hn-if");
  
  if (!product) {
    console.error('Product not found:', "gt10hn-if");
    return <div>Product not found</div>;
  }
  
  return (
    <SimpleProductPage 
      specificProductId="gt10hn-if"
      productName={product.name}
      productImage={getProductImage(product)}
      csvLookupId={getProductCsvLookupId(product)}
    />
  );
};

export default SimpleGT10HNIF; 